import base from "@/store/utils/api-route/base";

const api = {
  registerStatus: `${base.meta}cek_status_afiliasi_owner`,
  register: `${base.masterData}afiliasi/create_afiliator`,
  afiliasi: `${base.meta}info_dashboard_afiliasi`,
  lastWithdraw: `${base.meta}pencairan_afiliasi_latest`,
  dataRekening: `${base.meta}detail_rekening_afiliasi`,
  dataAfiliated: `${base.meta}jumlah_teman_dan_outlet_afiliasi`,
  mutasiSaldo: `${base.meta}list_history_mutasi_saldo_afiliasi`,
  withdrawHistory: `${base.meta}riwayat_pencairan_saldo_afiliasi`,
  listAfiliated: `${base.meta}list_teman_afiliasi`,
  listBank: `${base.meta}list_data_bank`,
  setBank: `${base.masterData}afiliasi/edit_afiliasi_rekening`,
  withdraw: `${base.masterData}afiliasi/pencairan_saldo_afiliasi`,
  sendOtp: `${base.auth}send_otp`,
  detailOwner: `${base.meta}data_detail_owner`,
  totalWithdraw: `${base.meta}total_pencairan_afiliasi`,
};

export default api;
